import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const CalendarEditIcon = ({ size = 24, color = Color.Gray400 }: IconProps) => (
  <svg width={size} height={(size * 17) / 16} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_15138_378428)">
      <path
        d="M3.08483 15.4022C2.72364 15.4022 2.41329 15.2724 2.15379 15.0129C1.89428 14.7534 1.76453 14.4431 1.76453 14.0819V3.9181C1.76453 3.55432 1.89428 3.24175 2.15379 2.9804C2.41329 2.71905 2.72364 2.58838 3.08483 2.58838H4.08338V1.58838H5.32686V2.58838H10.6732V1.58838H11.9167V2.58838H12.9153C13.279 2.58838 13.5916 2.71905 13.853 2.9804C14.1143 3.24175 14.245 3.55432 14.245 3.9181V9.00071H12.9153V6.99998H3.08483V14.0819H8.31671V15.4022H3.08483ZM15.0899 11.8746L13.6805 10.4652L14.1638 9.98188C14.2841 9.86159 14.4384 9.80145 14.6269 9.80145C14.8153 9.80145 14.9696 9.86159 15.0899 9.98188L15.5732 10.4652C15.6998 10.5918 15.7615 10.7477 15.7584 10.933C15.7552 11.1182 15.6935 11.271 15.5732 11.3913L15.0899 11.8746ZM9.31671 16.2384V14.829L12.9638 11.1819L14.3732 12.5913L10.7261 16.2384H9.31671Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_15138_378428">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
